import { gql } from '@apollo/client';

export const createContractGQL = gql`
  mutation createContract($input: CreateContractDto!) {
    createContract(input: $input) {
      _id
      ospContractId
      motoristId
      shortUid
      name1
      name2
      isEnabled
      stopDate
      startDate
      createdAt
      articleCode
      lang
      gender
      username
      reference
    }
  }
`;
